import "react-perfect-scrollbar/dist/css/styles.css";
import { useRoutes } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core";
import GlobalStyles from "src/components/GlobalStyles";
import "src/mixins/chartjs";
import theme from "src/theme";
import routes from "src/routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./app.css";
import "src/styles/host.css";

const App = () => {
  const isLoggedIn = localStorage.getItem("HOST_TOKEN");
  const routing = useRoutes(routes(isLoggedIn));

  return (
    <>
      <ToastContainer position="top-center" />
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        {routing}
      </ThemeProvider>
    </>
  );
};

export default App;
